import { render, staticRenderFns } from "./ProductMainVariants.vue?vue&type=template&id=330a4bf3"
import script from "./ProductMainVariants.vue?vue&type=script&lang=js"
export * from "./ProductMainVariants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports